<div class="ya-bottomsheet-container ya-typography">
  <div class="ya-bottomsheet-content-center">
    <div class="ya-bottomsheet-title-icon">
      <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-achtung"></div>
    </div>
    <h2 langkey="phNotificateVieSMS_Dialog_Title"></h2>
    <p>
      <span langkey="phNotificateVieSMS_Content"></span>
    </p>
    <p>
      <span langkey="phNotificateVieSMS_RequestContent"></span>
    </p>
    <ya-phone-number-input #phoneNumberInput></ya-phone-number-input>
    <div class="ya-button-group-wrapper">
      <div class="ya-button-group-container">
        <div class="ya-button-container">
          <button mat-flat-button (click)="setNotification()"
            [disabled]="!phoneNumberInput.inputFormControl.valid||phoneNumberInput.inputFormControl.value===''">
            <span langkey="phNotificateVieSMS_AcceptButton"></span>
          </button>
        </div>
      </div>
    </div>
    <div class="divider"></div>
    <p>
      <span
        [langkey]="!isInHouseGroupOrder?'phNotification_Dialog_DiscardContent':'phNotification_Dialog_DiscardContent_IHGroup'"></span>
    </p>
    <div class="ya-button-container">
      <button mat-flat-button class="ghostbutton" (click)="discardToMenuGroup()">
        <span
          [langkey]="!isInHouseGroupOrder?'phNotification_Dialog_DiscardButton':'phNotification_Dialog_DiscardButton_IHGroup'"></span>
      </button>
    </div>
    <div class="annotation">
      <span langkey="phNotificateVieSMS_Annotation"></span>
    </div>
  </div>
</div>